// Makes plain in-page anchor links (e.g. a "Ver Productos" button linking to
// `#shopify-section-...`) smooth-scroll to their target section.
//
// Horizon's squeeze layout (desktop >=990px) scrolls `.page-wrapper` instead of
// the document (which has `overflow: hidden`), so the browser's native
// "jump to fragment on click" never moves anything. This listens for clicks on
// same-page anchor links, prevents the default (no-op) navigation, and scrolls
// the correct container using the theme's own scrolling helpers.
import { scrollIntoView } from '@theme/scrolling';
import { getScrollContainer } from '@theme/scroll-container';

// @param {HTMLAnchorElement} anchor
// @returns {HTMLElement | null}
function getAnchorTarget(anchor) {
  const href = anchor.getAttribute('href');
    if (!href || href.charAt(0) !== '#' || href.length < 2) return null;
    
      try {
          return document.getElementById(href.slice(1));
            } catch (_) {
                return null;
                  }
                  }
                  
                  document.addEventListener(
                    'click',
                      (event) => {
                          if (event.defaultPrevented || event.button !== 0) return;
                          
                              const anchor = (event.target)?.closest?.('a[href^="#"]');
                                  if (!anchor) return;
                                  
                                      const target = getAnchorTarget(anchor);
                                          if (!target) return;
                                          
                                              event.preventDefault();
                                              
                                                  const container = getScrollContainer();
                                                      const isDocumentContainer = container === document.scrollingElement || container === document.documentElement;
                                                      
                                                          scrollIntoView(target, {
                                                                ancestor: isDocumentContainer ? undefined : container,
                                                                      behavior: 'smooth',
                                                                            block: 'start',
                                                                                });
                                                                                
                                                                                    if (location.hash !== anchor.hash) {
                                                                                          history.pushState(history.state, '', anchor.href);
                                                                                              }
                                            
                                                                                            },
                                                                                            true
                                                                                            );